import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import ElectricRickshawIcon from '@mui/icons-material/ElectricRickshaw';
import PersonIcon from '@mui/icons-material/Person';

export default function BottomPanel() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const [value, setValue] = useState(currentPath.includes('/protected/profile') ? 1 : 0);

    return (
        <Paper
            elevation={3}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: 'white',
            }}
        >
            <BottomNavigation
                showLabels
                value={value}
                onChange={(e, newValue) => {
                    if (newValue === 0) {
                        navigate('/protected/ride/idle');
                    } else if (newValue === 1) {
                        navigate('/protected/profile');
                    }
                }}
            >
                <BottomNavigationAction
                    label="Ride"
                    icon={<ElectricRickshawIcon />}
                    sx={{
                        '&.Mui-selected': {
                            color: 'rgb(0,119,77)',
                        },
                        color: 'gray',
                    }}
                />

                <BottomNavigationAction
                    label="Profile"
                    icon={<PersonIcon />}
                    sx={{
                        '&.Mui-selected': {
                            color: 'rgb(0,119,77)',
                        },
                        color: 'gray',
                    }}
                />
            </BottomNavigation>
        </Paper>
    );
}
